import { EnvironmentConfiguration } from '@models/environment-model';

export const environment: EnvironmentConfiguration = {
  production: true,
  stg: false,
  UrlBackEnd: "https://astornet.redsos.com.ar/Api/api/WebApp",
  ImgSources: "https://astornet.redsos.com.ar/Api/WebAppImages",
  ImagesBucket: "https://bucket.redsos.com.ar",
  covidSafeSettings: true,
  checkForUpdatesInterval: 1000 * 60 * 60 * 4, //4 horas
  googleMapsApiKey: "AIzaSyBhg6cVt1XR-cf3ZAYXrl78kpMsHudTUMU",
  InvalidDataContactPhone: "0800-333-6524",
  ExceptionRadios: [{
    radios: [414, 415],
    errorMsg: "Estimado cliente, para solicitar un servicio deberá comunicarse al teléfono 0800-122-1453."
  },
  {
    radios: [980, 981],
    errorMsg: "Estimado cliente, para solicitar un servicio deberá comunicarse al teléfono 0342-4103246."
  }]
};